import { api } from './BaseApi'
import {
  IComputeDishQuantity,
  ICreatePlanMenuDto,
  IOrderLine,
  IOrderLineDish,
  IPlanMenuDto,
  IPlanMenuRequest,
  IPlanMenuResponse,
  ISendPlanMenuToFotoboxesRequest,
} from './dto/PlanMenuDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const planMenuApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlanMenuList: builder.query<IPlanMenuResponse, IPlanMenuRequest>({
      query: (params) => ({
        url: `/plan_menu/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['PlanMenu', 'ВuffetDish', 'Order'],
    }),
    getPlanMenuSimpleList: builder.query<IPlanMenuResponse, IPlanMenuRequest>({
      query: (params) => ({
        url: `/plan_menu/get_plans_menu_simple_info/${createQueryStringSmart(
          params,
        )}`,
      }),
      providesTags: ['PlanMenu', 'ВuffetDish', 'Order'],
    }),
    getPlanMenuDetail: builder.query<IPlanMenuDto, { id: number }>({
      query: ({ id }) => ({
        url: `/plan_menu/${id}/`,
      }),
      providesTags: ['PlanMenu', 'ВuffetDish'],
    }),
    computeDishQuantity: builder.query<
      IComputeDishQuantity[],
      { id: number; count: number }
    >({
      query: ({ id, count }) => ({
        url: `/plan_menu/${id}/compute_dish_lines_quantity/`,
        params: { number_of_persons: count },
      }),
      providesTags: ['PlanMenu', 'ВuffetDish'],
    }),
    createPlanMenu: builder.mutation<IPlanMenuDto, ICreatePlanMenuDto>({
      query: (body) => ({
        method: 'POST',
        url: '/plan_menu/',
        body,
      }),
      invalidatesTags: ['PlanMenu', 'Order'],
    }),
    addedPlanMenuDishList: builder.mutation<
      IPlanMenuDto,
      { id: number; body: IOrderLineDish[] }
    >({
      query: ({ id, body }) => ({
        method: 'POST',
        url: `/plan_menu_dish/create_or_update_multiple_lines_dishes/${id}/`,
        body,
      }),
      invalidatesTags: ['PlanMenu', 'Order'],
    }),
    deletePlanMenuDishList: builder.mutation<
      IPlanMenuDto,
      { id: number; plan_menu_lines: string[] }
    >({
      query: ({ id, plan_menu_lines }) => ({
        method: 'POST',
        url: `/plan_menu_dish/archive_multiple_lines_dishes/${id}/`,
        body: { plan_menu_lines },
      }),
      invalidatesTags: ['PlanMenu'],
    }),
    updatePlanMenu: builder.mutation<
      IPlanMenuDto,
      { id: number; data: ICreatePlanMenuDto }
    >({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/plan_menu/${id}/`,
        body: data,
      }),
      invalidatesTags: ['PlanMenu', 'Order'],
    }),

    archiveMultiplePlanMenu: builder.mutation<
      IPlanMenuDto,
      { plan_menu_list: number[] }
    >({
      query: ({ plan_menu_list }) => ({
        method: 'PATCH',
        url: `/plan_menu/archive_multiple_plan_menu/`,
        body: { plan_menu_list },
      }),
      invalidatesTags: ['PlanMenu'],
    }),
  }),
})

export const {
  useGetPlanMenuListQuery,
  useGetPlanMenuSimpleListQuery,
  useGetPlanMenuDetailQuery,
  useComputeDishQuantityQuery,
  useCreatePlanMenuMutation,
  useUpdatePlanMenuMutation,
  useAddedPlanMenuDishListMutation,
  useDeletePlanMenuDishListMutation,
  useArchiveMultiplePlanMenuMutation,
} = planMenuApi
